import { TAppState } from '../../types';
import { ESubscriptionLevel } from '../../types/packages/subscriptionLevel';
import { selectBuyPackageModalData } from './selectBuyPackageModalData';
import { selectIsSubscription } from './selectIsSubscription';
import { selectSubscriptionLevel } from './selectSubscriptionLevel';

const SUBSCRIPTION_LEVEL_NAMES = {
  [ESubscriptionLevel.Bronze]: 'Бронза',
  [ESubscriptionLevel.Silver]: 'Серебро',
  [ESubscriptionLevel.Gold]: 'Золото',
  [ESubscriptionLevel.Platinum]: 'Платина',
};

export const selectBuyPackageModalTitle = (state: TAppState): string => {
  const { confirmationPopupTitle } = selectBuyPackageModalData(state);
  const level = selectSubscriptionLevel(state);
  const isSubscription = selectIsSubscription(state);

  if (confirmationPopupTitle) {
    return confirmationPopupTitle;
  }

  if (isSubscription && level) {
    return `Оплата подписки ${SUBSCRIPTION_LEVEL_NAMES[level]}`;
  }

  return 'Подтверждение покупки';
};
